export const APLICAR_TITULO = "Aplicar às Obras em FEL-0";
export const APLICAR_SUBTITULO = "Atualize cada Obra com os valores atuais desta referência.";
export const APLICAR_AVISO =
  "Do FEL-1 em diante nada muda: só as Obras em FEL-0 podem receber os valores atuais.";
export const APLICAR_NOTA_FECHAR = "As Obras às quais você não aplicar mantêm os valores atuais.";
export const APLICAR_VAZIO = "Nenhuma Obra em FEL-0 usa esta referência.";
export const APLICAR_CARREGANDO = "Carregando Obras...";
export const APLICAR_ERRO_LISTA = "Não foi possível carregar as Obras em FEL-0.";
export const APLICAR_SEM_PERMISSAO = "Você não tem permissão para aplicar a referência às Obras.";
export const APLICAR_ERRO_OBRA = "Não foi possível aplicar a referência a esta Obra.";

export const APLICAR_LABEL = "Aplicar";
export const APLICADA_LABEL = "Aplicada";
export const FECHAR_LABEL = "Fechar";
export const OK_LABEL = "OK";

export const APLICAR_TOAST_TITULO = "Sucesso";
export const aplicadaToast = (codigo: string) => `Referência aplicada à Obra ${codigo}.`;
export const escoposAfetados = (nomes: string[]) =>
  `${nomes.length} ${nomes.length === 1 ? "escopo afetado" : "escopos afetados"}: ${nomes.join(", ")}`;
